import React from 'react'
import { useAuth0 } from "@auth0/auth0-react";

const Login = () => {
  const { loginWithRedirect , logout , isAuthenticated , user } = useAuth0();
  return (
    <div>
         {
         isAuthenticated ?   <h4 to={""}> <a className="flex items-center gap-x-2 font-medium text-white/[.8] hover:text-white sm:border-l sm:border-white/[.3] sm:my-6 sm:pl-6" href="#">
         <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAY9JREFUSEvN1D9IlVEYBvCfDuViVJBYtDVIGQZJ1lCg4NDSKtHSUjg4JbaJi+EghJNR0CBBS4OrKDiIUwVBWpSL0RIUGaljlPLKuXHz3u/e+2kXPNMZznkfnj/v06DOp6HO8x0YgAu4jsu4mlgv4iVmsJylRDUGhzCGe2jMGPIH4xjBr91vKgGcwhzasYYJvMabNKQTXRjEUbzFTXwsBqnG4AHO4Q5+ZDBowVPcwDdcwafC22oAeUI2hduYTX7t/M0CCO0ncTcHwmGsIqTtKBhfDuAkphPVvAzvJ8MfYqgcg9AvhgdIJYZZxMKv91hCRPsficLIkCXkyXOKWTZjAz9xrB4AR7COTcS9xOT9SnQJr5JM57M03o/JwxjFIwz875g2pQVrRS/m95KSSuY/xy0soLvWTY6qOJ7obmVMjxQ9SUv5FRfxpRaA06nYTuADHuNZimD8D+Cohn604Tt68C5P2Z1JRfaXcgaL6J8A+pynrovfRvz6cA1n8RsrSe8XRRVegp+3a/Js+J665uABbANt30QZBx56CwAAAABJRU5ErkJggg=="/>
            <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
        Log Out
      </button>
          </a> </h4> :  <h4 to={""}> <a class="flex items-center gap-x-2 font-medium text-white/[.8] hover:text-white sm:border-l sm:border-white/[.3] sm:my-6 sm:pl-6" href="#">
          <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
          </svg>
          <button onClick={() => loginWithRedirect()}>Log In</button>
        </a> </h4>
       }
    </div>
  )
}

export default Login




